const FontAwesomeIcon = ({ iconName }) => {
  return <i className={`far fa-${iconName}`}></i>;
};

export default FontAwesomeIcon;
